@if (visible) {
    <ds-bottom-nav>
        @for (item of bottomNavService.evaluatedItems(); track trackByProp($index, item)) {
            <ds-bottom-nav-tab (click)="click($event, item)" [active]="isActive(item) | async">
                @if (getIconName(item) || getIconName2(item)) {
                    <div class="icon-wrapper">
                        @if (getIconName(item); as iconName) {
                            <vn-icon [name]="iconName" />
                        }
                        @if (getIconName2(item); as iconName2) {
                            <vn-icon [name]="iconName2" class="ui-icon ml-auto additional-icon" />
                        }
                        <ng-container *ngTemplateOutlet="badge" />
                    </div>
                } @else if (item.image) {
                    <vn-image
                        [alt]="item.image.alt"
                        [height]="item.image.height"
                        [imageClass]="'menu-item-img' + (item.parameters['image-class'] ? ' ' + item.parameters['image-class'] : '')"
                        [priority]="!lazyLoad"
                        [src]="item.image.src"
                        [width]="item.image.width" />
                    <ng-container *ngTemplateOutlet="badge" />
                }
                @if (item.text) {
                    @if (item.parameters.tooltip === 'true' && item.toolTip) {
                        <div
                            class="text-wrapper"
                            [dsTooltipTriggerFor]="tooltipTemplate"
                            position="top"
                            arrowPosition="start"
                            [autoOpen]="false"
                            [autoCloseTime]="10000"
                            [tooltipToggle]="false"
                            [fullWidth]="false"
                            [tooltipCustomClass]="item.parameters['tooltip-class'] ? item.parameters['tooltip-class'] : ''">
                            <ng-container *ngTemplateOutlet="text" />
                        </div>
                    } @else {
                        <div class="text-wrapper">
                            <ng-container *ngTemplateOutlet="text" />
                        </div>
                    }
                }
            </ds-bottom-nav-tab>
            <ng-template #tooltipTemplate>
                <ds-tooltip-content variant="neutral" inverse="false">
                    <div slot="description" [innerHtml]="item.toolTip | trustAsHtml"></div>
                </ds-tooltip-content>
            </ng-template>
            <ng-template #text>
                <vn-menu-item-text-content
                    cssClass="menu-item-txt"
                    [text]="item.text"
                    [renderHtmlText]="renderHtmlText(item)"
                    [attr.data-testid]="item.name"
                    [additionalClass]="!getIconName(item) && !getIconName2(item) ? 'account-amount' : ''" />
            </ng-template>
            <ng-template #badge>
                <ds-notification-bubble
                    style="position: absolute; top: -7px; right: -7px; z-index: 1"
                    vnMenuItemBadge
                    section="{{ MenuSection.BottomNav }}"
                    item="{{ item.name }}"></ds-notification-bubble>
            </ng-template>
        }
    </ds-bottom-nav>
}
